import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import "./category.css";
import { useNavigate } from "react-router-dom";
import All from "../../asset/all.png";

function Category() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadCategories();
  }, []);

const loadCategories = async () => {
    try {
      const res = await axiosInstance.get("categories/");
      setCategories(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
<div className="category-container">
      {loading ? (
        // Show 4-5 skeleton cards while loading
        [1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="category-card skeleton" style={{ height: "120px" }}>
             <div className="category-img skeleton" style={{ backgroundColor: '#444', margin: 'auto' }}></div>
          </div>
        ))
      ) : (
        <>
          <div className="category-card" onClick={() => navigate("/products/all")}>
            <img src={All} alt="All" className="category-img" />
            <span className="category-text">All</span>
          </div>
          {categories.map((cat) => (
            <div key={cat.id} className="category-card" onClick={() => navigate(`/products/${cat.name}`)}>
              <img src={cat.image || All} alt={cat.name} className="category-img" />
              <span className="category-text">{cat.name}</span>
            </div>
          ))}
        </>
      )}
    </div>
  );
}

export default Category;
